import type { BreakpointsType } from "@simplybusiness/mobius";

export const customBreakpoints = [
  { size: "xs", value: 320 },
  { size: "sm", value: 480 },
  { size: "md", value: 600 },
  { size: "lg", value: 850 },
  { size: "xl", value: 1024 },
] as BreakpointsType;
